import { _axios } from "@/plugins/axios";

class ConcejoMunicipalService {
  async getConcejales() {
    return _axios.get("/concejo-municipal").then((response: any) => {
      return response.data;
    });
  }

  async getExpansibles() {
    return _axios.get("/concejo-municipal/expansibles").then((response: any) => {
      return response.data;
    });
  }
}

export default new ConcejoMunicipalService();
